export const GetPackagingText = (
    packaging: Record<string, number> | string[]
) => {
    if (Array.isArray(packaging)) {
        return packaging.join(', ');
    } else if (typeof packaging === 'object' && packaging !== null) {
        const [key, value] = Object.entries(packaging)[0];
        return `${value} ${key}`;
    }

    return '';
};
